import { DeleteOutlined } from '@ant-design/icons'
import { Button, Checkbox, Col, Input, Row, Select, InputNumber } from 'antd'
import { useState } from 'react'
import { CHECKPOINTS_TYPES } from '../../constant'
import CollapseHeader from '../CollapseHeader/CollapseHeader'
import { isEmptyValue } from '@/utils/common'
import './TemplateCheckPoint.style.less'
import { FIELD_INPUT_TYPE } from '@/screens/Order/Pages/Order.constant'
import {
  DEPENDENT_CONTROL_TYPES,
  getDependency,
} from '@/utils/checkpointDependency'
import {
  CheckpointDependencyMapOptions,
  CheckpointDependencyTrigger,
  DependsOnCheckbox,
} from './CheckpointDependencyConfig'

interface Props {
  item: any
  index: any
  subIndex: any
  checkpointIndex: any
  sections: any[]
  onDeleteCheckpoint: (index, subIndex, checkpointIndex) => void
  onCheckpointNameChange: (index, subIndex, checkpointIndex, value) => void
  onChangeCheckpointControlType: (
    index,
    subIndex,
    checkpointIndex,
    value
  ) => void
  onCheckPointMandatory: (index, subIndex, checkpointIndex, value) => void
  isSelect: boolean
  onAddDataSource: (index, subIndex, checkpointIndex, value) => void
  datasource: any[]
  onRemoveDatasource: (
    index,
    subIndex,
    checkpointIndex,
    datasourceIndex
  ) => void
  onCheckPointHidden: (
    sectionIndex,
    subSectionIndex,
    checkpointIndex,
    value
  ) => void
  onCheckPointHasDefaultValue: (
    sectionIndex,
    subSectionIndex,
    checkpointIndex,
    value
  ) => void
  onCheckPointDefaultValueChange: (
    sectionIndex,
    subSectionIndex,
    checkpointIndex,
    value
  ) => void
  onToggleDependsOn: (index, subIndex, checkpointIndex, enabled) => void
  onChangeDependencyTrigger: (
    index,
    subIndex,
    checkpointIndex,
    triggerName
  ) => void
  onToggleMappedOption: (
    index,
    subIndex,
    checkpointIndex,
    triggerValue,
    optionValue,
    checked
  ) => void
  onSetAllMappedOptions: (
    index,
    subIndex,
    checkpointIndex,
    triggerValue,
    selectAll: boolean
  ) => void
}

function TemplateCheckPoint(props: Props) {
  const {
    item,
    index,
    subIndex,
    checkpointIndex,
    sections,
    isSelect,
    onDeleteCheckpoint,
    onCheckpointNameChange,
    onChangeCheckpointControlType,
    onAddDataSource,
    onRemoveDatasource,
    onCheckPointHidden,
    onCheckPointHasDefaultValue,
    onCheckPointDefaultValueChange,
    onToggleDependsOn,
    onChangeDependencyTrigger,
    onToggleMappedOption,
    onSetAllMappedOptions,
  } = props

  const [datasourceValue, setdatasourceValue] = useState('')

  const isTextOrNumber =
    item.control_type === FIELD_INPUT_TYPE.TEXT ||
    item.control_type === FIELD_INPUT_TYPE.NUMBER
  const canDepend = (DEPENDENT_CONTROL_TYPES as readonly string[]).includes(
    item.control_type
  )

  return (
    <div className="checkpoint-container">
      <div className="checkpoint-header-container">
        <Row>
          <Col span={3} />
          <Col span={21}>
            <CollapseHeader
              value={item}
              title={'Checkpoint Name'}
              onChangeName={(value) =>
                onCheckpointNameChange(index, subIndex, checkpointIndex, value)
              }
              onDeleteSection={() =>
                onDeleteCheckpoint(index, subIndex, checkpointIndex)
              }
            />
          </Col>
        </Row>
        <Row>
          <Col span={3} />
          <Col span={21}>
            <Row className="checkpoint-type-container">
              <p className="label-name">Checkpoint Type</p>
              <Select
                size="large"
                placeholder="Select"
                value={item.control_type}
                status={!item.control_type ? 'error' : ''}
                onChange={(value) =>
                  onChangeCheckpointControlType(
                    index,
                    subIndex,
                    checkpointIndex,
                    value
                  )
                }
              >
                {CHECKPOINTS_TYPES?.map((typeItem: any, typeIndex: number) => (
                  <Select.Option key={typeIndex} value={typeItem.value}>
                    {typeItem.label}
                  </Select.Option>
                ))}
              </Select>
            </Row>

            <Row
              align={'middle'}
              wrap={false}
              className="checkpoint-option-container"
            >
              <Col span={5}>
                <p className="label">Options</p>
              </Col>
              <Col flex="auto" className="checkpoint-option-fields">
                <Checkbox
                  onChange={(e) =>
                    props.onCheckPointMandatory(
                      index,
                      subIndex,
                      checkpointIndex,
                      e.target.checked
                    )
                  }
                  checked={item.validations.is_required}
                >
                  Mandatory
                </Checkbox>
                {canDepend && (
                  <DependsOnCheckbox
                    item={item}
                    sections={sections}
                    onToggleDependsOn={(enabled) =>
                      onToggleDependsOn(
                        index,
                        subIndex,
                        checkpointIndex,
                        enabled
                      )
                    }
                  />
                )}
                {canDepend && (
                  <CheckpointDependencyTrigger
                    item={item}
                    sections={sections}
                    sectionIndex={index}
                    subIndex={subIndex}
                    checkpointIndex={checkpointIndex}
                    onChangeDependencyTrigger={(triggerName) =>
                      onChangeDependencyTrigger(
                        index,
                        subIndex,
                        checkpointIndex,
                        triggerName
                      )
                    }
                  />
                )}
                {isTextOrNumber && (
                  <Checkbox
                    onChange={(e) =>
                      onCheckPointHidden(
                        index,
                        subIndex,
                        checkpointIndex,
                        e.target.checked
                      )
                    }
                    checked={item.options?.hidden ?? false}
                    style={{ marginLeft: 16 }}
                  >
                    Hidden
                  </Checkbox>
                )}
              </Col>
            </Row>

            {isTextOrNumber && (
              <Row align={'middle'} className="checkpoint-option-container">
                <Col span={5}>
                  <Checkbox
                    onChange={(e) =>
                      onCheckPointHasDefaultValue(
                        index,
                        subIndex,
                        checkpointIndex,
                        e.target.checked
                      )
                    }
                    checked={item.options?.default_value?.status ?? false}
                    className="label "
                  >
                    Default Value
                  </Checkbox>
                </Col>
                {item.options?.default_value?.status && (
                  <Col span={18}>
                    {item.control_type === FIELD_INPUT_TYPE.NUMBER ? (
                      <InputNumber
                        placeholder="Number"
                        value={item.options?.default_value?.value}
                        size="large"
                        status={
                          item.options?.default_value?.status &&
                          isEmptyValue(item.options?.default_value?.value)
                            ? 'error'
                            : ''
                        }
                        onChange={(value) => {
                          onCheckPointDefaultValueChange(
                            index,
                            subIndex,
                            checkpointIndex,
                            value
                          )
                        }}
                        style={{ width: '96.6%' }}
                        onWheel={(e: any) => e.target.blur()}
                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                        }
                      />
                    ) : (
                      <Input
                        placeholder="Text"
                        value={item.options?.default_value?.value ?? ''}
                        size="large"
                        status={
                          item.options?.default_value?.status &&
                          isEmptyValue(item.options?.default_value?.value)
                            ? 'error'
                            : ''
                        }
                        onChange={(e) => {
                          onCheckPointDefaultValueChange(
                            index,
                            subIndex,
                            checkpointIndex,
                            e.target.value
                          )
                        }}
                        style={{ maxWidth: '96.6%' }}
                      />
                    )}
                  </Col>
                )}
              </Row>
            )}

            {isSelect && (
              <>
                <Row align={'middle'} className="checkpoint-option-container">
                  <Col span={6}>
                    <p className="label">Data Source</p>
                  </Col>
                  <Col span={10}>
                    <Input
                      value={datasourceValue}
                      size="large"
                      onChange={(e) => setdatasourceValue(e.target.value)}
                    />
                  </Col>
                  <Col span={6}>
                    <Button
                      onClick={() => {
                        onAddDataSource(
                          index,
                          subIndex,
                          checkpointIndex,
                          datasourceValue
                        )
                        setdatasourceValue('')
                      }}
                      className="button-datasource"
                      size="large"
                    >
                      Add
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col span={6} />
                  <Col span={10}>
                    {item.data_source?.map((dsItem, dIndex) => (
                      <Row
                        key={dIndex}
                        className="datasource-container"
                        align="middle"
                        justify={'space-between'}
                      >
                        <p className="datasource-label">{dsItem.value}</p>
                        <Col>
                          <Button
                            size="large"
                            onClick={() =>
                              onRemoveDatasource(
                                index,
                                subIndex,
                                checkpointIndex,
                                dIndex
                              )
                            }
                          >
                            <DeleteOutlined className="delete-icon" />
                          </Button>
                        </Col>
                      </Row>
                    ))}
                  </Col>
                </Row>
              </>
            )}

            {canDepend && getDependency(item) && (
              <CheckpointDependencyMapOptions
                item={item}
                sections={sections}
                onToggleMappedOption={(triggerValue, optionValue, checked) =>
                  onToggleMappedOption(
                    index,
                    subIndex,
                    checkpointIndex,
                    triggerValue,
                    optionValue,
                    checked
                  )
                }
                onSelectAllMappedOptions={(triggerValue) =>
                  onSetAllMappedOptions(
                    index,
                    subIndex,
                    checkpointIndex,
                    triggerValue,
                    true
                  )
                }
              />
            )}
          </Col>
        </Row>
        <div className="border-line" />
      </div>
    </div>
  )
}

export default TemplateCheckPoint
